<div class="options-inner">
  <div (click)="select('yes')">
    <a class="cnt-button-secondary w-button" [class.selected]="selection === 'yes'">Yes</a>
  </div>
  <div (click)="select('no')">
    <a class="cnt-button-secondary w-button" [class.selected]="selection === 'no'">No</a>
  </div>
  <div (click)="select('not-sure')">
    <a class="cnt-button-secondary w-button" [class.selected]="selection === 'not-sure'">I&rsquo;m Not Sure</a>
  </div>
</div>
